var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      [
        _c(
          "el-card",
          { staticClass: "box-card", attrs: { bordered: false } },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingList,
                    expression: "loadingList",
                  },
                ],
                ref: "table",
                staticClass: "mt25",
                attrs: {
                  data: _vm.levelLists,
                  size: "small",
                  "header-cell-style": { fontWeight: "bold" },
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("xuhao"),
                    type: "index",
                    "min-width": "130",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: _vm.$t("tzlx"), prop: "type" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                scope.row.type == 1
                                  ? _vm.$t("cz")
                                  : scope.row.type == 2
                                  ? _vm.$t("tixian")
                                  : _vm.$t("shiming")
                              ) +
                              _vm._s(_vm.$t("xiaoxi")) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: _vm.$t("neirong"), prop: "explain" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: _vm.$t("status"), prop: "is_read" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                scope.row.is_read == 0
                                  ? _vm.$t("weidu")
                                  : _vm.$t("yidu")
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: _vm.$t("setting") },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.setting(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("bjyd")))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }